export var PromotionBannerVariant;
(function (PromotionBannerVariant) {
    PromotionBannerVariant["Small"] = "small";
    PromotionBannerVariant["Large"] = "large";
})(PromotionBannerVariant || (PromotionBannerVariant = {}));
